import { useEffect, useState, useRef } from "react";
import useGetClientId from "../hooks/useGetClientId";
import {
  GET_ALL_PROPERTY_AND_ROLE_BASED_ON_CLIENT_ID,
  INVITE_MEMEBER_AND_ASSIGN_PROPERTY_V2,
} from "../api/apiPath";
import http from "../api/server";
import Toaster from "./common/Toaster";
import useGetCity from "../hooks/useGetCity";
import PhoneNumber from "./common/PhoneNumber";

const UpdateUser = (props) => {
  const { entriesData, setShowEditMember } = props;
  // const entriesData = [
  //   {
  //     active: true,
  //     cityId: 2,
  //     cityName: "Manchester",
  //     fullName: "2 2",
  //     id: 2,
  //     phoneNumber: "919598265300",
  //     roleId: 1,
  //     roleName: "Admin",
  //     userEmail: "2@gmail.com",
  //     userId: 107,
  //     userStatus: "Active",
  //     userType: "Contractor",
  //     firstName: "shubham",
  //     lastName: "singh",
  //   },
  // ];
  const [allRoles, setAllRoles] = useState(null);
  const [city, setCity] = useState(null);
  const clientObj = useGetClientId();
  const cityObj = useGetCity();
  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  useEffect(() => {
    setCity(cityObj?.cityList);
  }, [cityObj.cityList, cityObj.loading]);
  console.log(cityObj);
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };
  console.log("entriesData", entriesData);
  

  const handleGetAllPropertyByClinetID = async (clientId) => {
    try {
      const response = await http.get(
        GET_ALL_PROPERTY_AND_ROLE_BASED_ON_CLIENT_ID + "?clientId=" + clientId
      );
      if (response.status === 200) {
        setAllRoles(response.data.roles);
        console.log("roleId", response.data.roles);
      }
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (clientObj.clientId) {
      handleGetAllPropertyByClinetID(clientObj.clientId);
    }
  }, [clientObj.clientId, clientObj.loading]);

  const [entries, setEntries] = useState(entriesData);
  const handleChange = (id, field, value) => {
    setEntries(
      entries?.map((entry) =>
        entry.id === id ? { ...entry, [field]: value } : entry,
  
      )
    );
  };

  const firstNameRef = useRef({});
  const lastNameRef = useRef({});
  const emailRef = useRef({});
  const phoneRef = useRef({});
  const typeRef = useRef({});
  const cityRef = useRef({});
  const roleRef = useRef({});

  const handleSave = (event) => {
    event.preventDefault();
    console.log(entries);
    let isValid = true;

    entries.forEach((entry) => {
      const fRef = firstNameRef.current[entry.id];
      if (!(entry.firstName ?? "").trim()) {
        if (fRef) fRef.style.border = "1px solid red";
        isValid = false;
      } else {
        if (fRef) fRef.style.border = "1px solid #ced4da";
      }

      const lRef = lastNameRef.current[entry.id];
      if (!(entry.lastName ?? "").trim()) {
        if (lRef) lRef.style.border = "1px solid red";
        isValid = false;
      } else {
        if (lRef) lRef.style.border = "1px solid #ced4da";
      }

      const eRef = emailRef.current[entry.id];
      if (!(entry.userEmail ?? "").trim()) {
        if (eRef) eRef.style.border = "1px solid red";
        isValid = false;
      } else {
        if (eRef) eRef.style.border = "1px solid #ced4da";
      }

      // if (!entry.phoneNumber) {
      //   const input = phoneRef.current[entry.id];
      //   if (input) {
      //     input.parentNode.style.border = "1px solid red";
      //   }
      // }

      const tRef = typeRef.current[entry.id];
      if (!(entry.userType ?? "").trim()) {
        if (tRef) tRef.style.border = "1px solid red";
        isValid = false;
      } else {
        if (tRef) tRef.style.border = "1px solid #ced4da";
      }

      const cRef = cityRef.current[entry.id];
      if (!(entry.cityId ?? "")) {
        if (cRef) cRef.style.border = "1px solid red";
        isValid = false;
      } else {
        if (cRef) cRef.style.border = "1px solid #ced4da";
      }

      const rRef = roleRef.current[entry.id];
      if (!(entry?.roleId ?? "")) {
        if (rRef) rRef.style.border = "1px solid red";
        isValid = false;
      } else {
        if (rRef) rRef.style.border = "1px solid #ced4da";
      }
    });

    if (!isValid) {
      return;
    }

    handleInviteUser();
  };

  const handleInviteUser = async () => {
    console.log(entries);
    const payload = entries?.map((item) => ({
      clientId: clientObj.clientId,
      //propertyId: item?.propertyName?.value,
      roleId: item.roleId,
      userEmail: item.userEmail,
      userId: item.userId,
      firstName: item.firstName,
      lastName: item.lastName,
      phoneNumber: item.phoneNumber,
      userType: item.userType,
      cityId: item.cityId,
      userStatus: item.userStatus,

       HasRoleChanged:
      item.roleId !==
      entriesData.find((e) => e.id === item.id)?.roleId
        ? true
        : false,

    }));
    const finalPayload = {
      assignments: payload,
    };

    try {
      const response = await http.post(
        INVITE_MEMEBER_AND_ASSIGN_PROPERTY_V2,
        finalPayload
      );

      if (response.status === 200) {
        setToastData({
          toastShow: true,
          toastType: "success",
          toastString: "Members are successfully invited",
        });
        setTimeout(() => {
          setShowEditMember(false);
        }, 2000);
        setEntries([
          {
            id: 1,
            userEmail: "",
            roleId: "",
            propertyName: "",
            firstName: "",
            lastName: "",
            phoneNumber: "",
            userType: "",
            status: "",
            city: "",
          }, // Initial entry
        ]);
      }

      if (!response.status) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      }
    } catch (error) {
      if (error.status === 400) {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: error?.data?.title,
        });
      }
    }
  };

  //const [propertyCity, setPropertyCity] = useState(editPropertyDetails?.city);

  return (
    <>
      <div className="d-flex dashboard_body flex-column py-1 w-100">
        <div className="row m-0 p-0 mt-3 mb-2">
          {/* <h6 className="modal-header" style={{ backgroundColor: "#081634" }}>
            Update User
          </h6> */}
          <p className="text-start mb-4 fs-3 fw-bold m-0"> Update User</p>
          {/* <div className="d-flex dashboard_body flex-column py-1 w-100"> */}
          {/* <div className="row m-4"> */}
          <div className="card w-100 box_shadow">
          <div className="card-body modal-scroll">
          {entries?.map((entry) => (
            // eslint-disable-next-line react/jsx-key,
            <>
              <div>
                <div
                  className="row w-150 align-items-center row-gap-2"
                  style={{
                    margin: "10px",
                    marginBottom: "20px",
                    padding: "15px",
                    border: "1px solid #ccc",
                  }}
                >
                  <div
                    
                    style={{ width: "50%", textAlign: "justify" }}
                  >
                    <label htmlFor="firstname">
                      First Name
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      maxLength="50"
                      className="form-control"
                      id="firstname"
                      required
                      placeholder="FirstName"
                      value={entry.firstName}
                      ref={(el) => (firstNameRef.current[entry.id] = el)}
                      onChange={(e) =>
                        handleChange(entry.id, "firstName", e.target.value)
                      }
                    />
                  </div>

                  <div
                    style={{ width: "50%", textAlign: "justify" }}
                  >
                    <label htmlFor="floatingInput">
                      Last Name
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="lastname"
                      maxLength="50"
                      className="form-control"
                      id="floatingInput"
                      placeholder="LastName"
                      required
                      value={entry.lastName}
                      ref={(el) => (lastNameRef.current[entry.id] = el)}
                      onChange={(e) =>
                        handleChange(entry.id, "lastName", e.target.value)
                      }
                    />
                  </div>

                  <div
                    style={{ width: "50%", textAlign: "justify" }}
                  >
                    <label htmlFor="floatingInput">
                      Email<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="userEmail"
                      className="form-control"
                      id="floatingInput"
                      placeholder="sample@example.com"
                      value={entry.userEmail}
                      ref={(el) => (emailRef.current[entry.id] = el)}
                      onChange={(e) =>
                        handleChange(entry.id, "userEmail", e.target.value)
                      }
                      required
                    />
                  </div>
                  <div
                    className="react-tele-input"
                    style={{
                      width: "50%",
                      marginTop: "-15px",
                      textAlign: "justify",
                    }}
                  >
                    <label htmlFor="floatingInput">
                      Mobile Number
                    </label>
                    <PhoneNumber
                      setPhoneNumber={(e) => {
                        handleChange(entry.id, "phoneNumber", e.mobileNumber);
                      }}
                      phoneNumber={entry.phoneNumber}
                      inputRef={(el) => (phoneRef.current[entry.id] = el)}
                    />
                  </div>
                  <div
                    style={{ width: "50%", textAlign: "justify" }}
                  >
                    <label htmlFor={`userType-${entry.id}`}>
                      User Type<span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className="form-select"
                      name="userType"
                      id={`userType-${entry.id}`}
                      value={entry.userType || ""}
                      ref={(el) => (typeRef.current[entry.id] = el)}
                      onChange={(e) =>
                        handleChange(entry.id, "userType", e.target.value)
                      }
                    >
                      <option value="">Select Type</option>
                      <option value="Internal Staff">Internal staff</option>
                      <option value="Contractor">Contractor</option>
                    </select>
                  </div>
                  <div
                    style={{ width: "50%", textAlign: "justify" }}
                  >
                    <label htmlFor={`city-${entry.id}`}>
                      City<span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className="form-select"
                      name="city"
                      id={`city-${entry.id}`}
                      aria-label="Floating label select example"
                      value={entry.cityId}
                      ref={(el) => (cityRef.current[entry.id] = el)}
                      onChange={(e) =>
                        handleChange(entry.id, "cityId", e.target.value)
                      }
                    >
                      <option value="">Select City</option>
                      {city?.map((data) => (
                        <option key={data?.cityId} value={data?.cityId}>
                          {data.cityName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div
                    style={{ width: "50%", textAlign: "justify" }}
                  >
                    <label htmlFor={`roleId-${entry.id}`}>
                      Role<span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className="form-select"
                      name="roleId"
                      id={`roleId-${entry.id}`}
                      aria-label="Floating label select example"
                      value={entry.roleId}
                      ref={(el) => (roleRef.current[entry.id] = el)}
                      onChange={(e) =>
                        handleChange(entry.id, "roleId", e.target.value)
                      }
                    >
                      <option value="">Select a Role</option>
                      {allRoles?.map((data) => (
                        <option key={data?.roleId} value={data?.roleId}>
                          {data.roleName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div
                    style={{ width: "50%", textAlign: "justify" }}
                  >
                    <label htmlFor="floatingSelect">
                      Status
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className="form-select"
                      name="roleId"
                      id="floatingSelect"
                      aria-label="Floating label select example"
                      value={entry.userStatus}
                      onChange={(e) =>
                        handleChange(entry.id, "userStatus", e.target.value)
                      }
                    >
                      <option value="active">Active</option>
                      <option value="archived">Archived</option>
                    </select>
                  </div>
                </div>

                {/* <hr /> */}
              </div>
            </>
          ))}
          </div></div>

          <div className="d-flex align-items-center mt-3 justify-content-end">
            <button
              type="button"
              className="btn btn-secondary me-3 px-5"
              onClick={() => setShowEditMember(false)}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary px-5"
              onClick={handleSave}
              style={{
                marginRight: "10px",
              }}
            >
              Update Member
            </button>
          </div>
          {/* </div> */}
          {/* </div> */}

          <Toaster
            show={toastData.toastShow}
            toastType={toastData.toastType}
            title={toastData.toastString}
            theme={"dark"}
            position="top-center"
            closeButton={() => {
              closeButton();
            }}
          />
          {/* </div> */}
          {/* </div> */}
        </div>
      </div>
    </>
  );
};
export default UpdateUser;
